import script from "./OfflineDatatable.vue?vue&type=script&setup=true&lang=js"
export * from "./OfflineDatatable.vue?vue&type=script&setup=true&lang=js"

import "./OfflineDatatable.vue?vue&type=style&index=0&id=6443aa92&lang=scss"

const __exports__ = script;

export default __exports__